var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_1276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7005 15.19C27.4405 8.90002 22.8505 3.86002 17.5005 1.75002C13.5705 0.190019 7.27052 -0.559981 5.51052 2.23002C4.63052 3.63002 4.85052 5.97002 5.61052 7.59002C6.59052 9.69002 8.33052 10.29 8.09052 11.05C7.72052 12.25 3.41052 10.72 1.51052 12.63C-0.969483 15.12 2.24052 21.83 2.41052 22.18C2.82052 23.01 6.97052 31.13 15.6405 31.87C17.0305 31.99 21.8405 32.4 25.4805 29.13C30.5705 24.56 29.0105 16.74 28.7005 15.19ZM13.9405 17.46C13.2105 18.05 11.7505 17.44 10.6805 16.11C9.62052 14.78 9.35052 13.23 10.0805 12.64C10.8105 12.05 12.2705 12.66 13.3405 13.99C14.4105 15.32 14.6805 16.87 13.9405 17.46Z",
    fill: "url(#paint0_linear_239_1276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9605 14.89C27.7005 8.60001 23.1005 3.55001 17.7505 1.44001C13.8205 -0.109988 7.52053 -0.859988 5.77053 1.93001C4.89053 3.33001 5.11053 5.67001 5.87053 7.29001C6.85053 9.39001 8.59053 9.99001 8.35053 10.75C7.98053 11.95 3.67053 10.42 1.77053 12.33C-0.709474 14.82 2.50053 21.53 2.67053 21.88C3.08053 22.71 7.23053 30.83 15.9005 31.57C17.2905 31.69 22.1005 32.1 25.7405 28.83C30.8405 24.25 29.2705 16.44 28.9605 14.89ZM14.2005 17.16C13.4705 17.75 12.0105 17.14 10.9405 15.81C9.87053 14.48 9.61053 12.93 10.3405 12.34C11.0705 11.75 12.5305 12.36 13.6005 13.69C14.6605 15.02 14.9305 16.57 14.2005 17.16Z",
    fill: "url(#paint1_linear_239_1276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7606 2.40001C14.3806 2.05001 12.7906 2.66001 12.0506 3.86001C11.3706 4.95001 11.1906 6.90001 12.4806 7.93001C13.4206 8.68001 14.9806 8.80001 15.9906 7.90001C16.8006 7.17001 17.1306 5.90001 16.7006 5.11001C16.2406 4.26001 15.0606 4.30001 14.8206 3.36001C14.6806 2.85001 14.9306 2.58001 14.7606 2.40001Z",
    fill: "url(#paint2_linear_239_1276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0305 6.40002C19.6805 6.12002 18.1505 6.89002 17.5605 8.15002C16.8105 9.75002 17.4205 12.45 19.2505 12.96C20.4605 13.29 21.8605 12.59 22.5305 11.46C23.1505 10.43 23.2205 8.88002 22.5005 8.24002C21.7705 7.60002 20.5205 8.15002 20.1305 7.46002C19.8705 7.03002 20.2405 6.56002 20.0305 6.40002Z",
    fill: "url(#paint3_linear_239_1276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0505 17.28C24.8305 17.54 26.1805 16.4 26.5905 15.1C27.0805 13.51 26.2405 11.3 24.9305 11.1C23.7405 10.93 22.3505 12.41 22.2705 13.76C22.2305 14.44 22.6205 15.13 23.4105 16.49C23.7505 17.1 23.8905 17.22 24.0505 17.28Z",
    fill: "url(#paint4_linear_239_1276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7805 18.54C26.6805 18.31 25.1305 18.4 24.0805 19.32C23.3005 20.01 22.5405 21.39 23.0805 22.76C23.4405 23.7 24.3805 24.58 25.3905 24.55C27.2505 24.5 28.4705 21.36 27.7605 20.26C27.4205 19.73 26.5105 19.5 26.5605 18.99C26.5805 18.74 26.8305 18.64 26.7805 18.54Z",
    fill: "url(#paint5_linear_239_1276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9606 23.94C15.9106 23.51 17.4706 22.7 19.1106 22.74C19.5506 22.75 21.8106 22.8 22.8806 24.66C23.5506 25.84 23.7006 27.66 22.6206 28.78C21.6806 29.76 20.3306 29.67 20.0806 29.66C18.6706 29.57 17.2006 28.61 16.9606 27.42C16.7306 26.28 17.7306 25.48 17.2506 24.72C16.8706 24.11 15.9906 24.26 15.9506 23.94H15.9606Z",
    fill: "url(#paint6_linear_239_1276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5206 23.16C12.1206 23.1 12.2406 22.22 12.6606 22.22C13.1506 22.22 13.6006 23.41 13.7306 24.43C13.7706 24.72 14.0906 27.21 12.8806 27.94C11.5306 28.75 8.58056 27.16 7.88056 24.88C7.24056 22.83 8.52056 20.56 9.08056 20.59C9.41056 20.61 9.43056 21.4 10.4506 22.47C11.0906 23.17 11.4006 23.17 11.5206 23.16Z",
    fill: "url(#paint7_linear_239_1276)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_1276",
    x1: 15.0546,
    y1: 17.3807,
    x2: 23.4954,
    y2: 46.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_239_1276",
    x1: 15.3145,
    y1: 17.0748,
    x2: 23.7622,
    y2: 46.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_239_1276",
    x1: 14.3344,
    y1: 1.96721,
    x2: 13.9047,
    y2: 14.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_239_1276",
    x1: 21.4576,
    y1: -0.706975,
    x2: 20.0231,
    y2: 10.4712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_239_1276",
    x1: 29.8612,
    y1: 6.7087,
    x2: 18.4266,
    y2: 22.5578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_239_1276",
    x1: 22.9031,
    y1: 21.4956,
    x2: 27.9665,
    y2: 21.4956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_239_1276",
    x1: 19.6479,
    y1: 25.8903,
    x2: 20.5557,
    y2: 14.4557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_239_1276",
    x1: 10.7463,
    y1: 24.3654,
    x2: 11.0097,
    y2: 41.1292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_1276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 32,
    fill: "white",
    transform: "translate(0.000488281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcon);
export default __webpack_public_path__ + "static/media/designIcon.dc4fda8a0b19c64039e14c9a184d15aa.svg";
export { ForwardRef as ReactComponent };